/**
 * Loading Spinner Component
 * Phase 4: Reusable spinner for async operations
 */

import React from 'react';
import '../styles/LoadingSpinner.css';

export interface LoadingSpinnerProps {
  /**
   * Size of the spinner in pixels
   * @default 16
   */
  size?: number;

  /**
   * Color of the spinner
   * @default 'currentColor'
   */
  color?: string;

  /**
   * Whether to show inline or block
   * @default 'inline'
   */
  display?: 'inline' | 'block';
}

/**
 * Loading Spinner - Animated spinner for loading states
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 16,
  color = 'currentColor',
  display = 'inline',
}) => {
  return (
    <svg
      className={`af-loading-spinner af-loading-spinner--${display}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Loading"
      role="status"
    >
      <circle
        className="af-loading-spinner__circle"
        cx="12"
        cy="12"
        r="10"
        stroke={color}
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default LoadingSpinner;
